// Utilities
import {
  LocalStoreManager,
  getAppCustomEnv,
} from "@sleek/customer-common-acquisition";
import {
  SET_PLATFORM_CONFIG,
  CLEAR_PLATFORM_CONFIG,
  SET_IS_LOADING,
} from "../constants/config-constants";

const localStore = new LocalStoreManager();

import { getPlatformConfig } from "./get-platform-config";
// initial state
function initialState() {
  return {
    platformConfig: {},
    isLoading: false,
    IS_BILLING_PROFILE: true,
    isLogin: false,
    phoneCodeList: [],
    phoneCode: "",
    country: "",
  };
}

const state = initialState;

// getters
const getters = {
  platformConfig: (state) => state.platformConfig,
  getIsLoading: (state) => state.isLoading,
  isBillingProfile: (state) => state.IS_BILLING_PROFILE,
  getIsLogin: (state) => state.isLogin || localStore.getIsLogin(),
  getPhoneCodeList: (state) => state.phoneCodeList,
};

// actions
const actions = {
  // eslint-disable-next-line no-unused-vars
  async GET_PLATFORM_CONFIG({ dispatch }) {
    console.log("GET_PLATFORM_CONFIG");
    const fetchConfig = await getPlatformConfig();
    await dispatch("SET_PLATFORM_CONFIG", fetchConfig);

    return fetchConfig;
  },
  async SET_PLATFORM_CONFIG({ commit }, payload) {
    const appCustomEnv = await getAppCustomEnv();
    localStore.setLastKnownBuildVersion(appCustomEnv.VUE_APP_BUILD_NUMBER);
    commit(SET_PLATFORM_CONFIG, payload);
  },
  CLEAR_PLATFORM_CONFIG({ commit }, payload) {
    localStore.setLastKnownBuildVersion(null);
    commit(CLEAR_PLATFORM_CONFIG, payload);
  },
  SET_IS_LOADING({ commit }, payload) {
    commit(SET_IS_LOADING, payload);
  },
  enableOTPListerner({ commit }, payload) {
    if (payload) {
      commit("userModule/setUser", payload.user, {
        root: true,
      });
      commit("userModule/setUserFormData", payload.userFormData, {
        root: true,
      });
    }
  },
  resendOTP() {},
};

// mutations
const mutations = {
  SET_PLATFORM_CONFIG(state, payload) {
    console.log("SET_PLATFORM_CONFIG", payload);
    state.platformConfig = payload;
  },
  // eslint-disable-next-line no-unused-vars
  CLEAR_PLATFORM_CONFIG(state, payload) {
    state.platformConfig = {};
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_IS_BILLING_PROFILE(state, payload) {
    state.IS_BILLING_PROFILE = payload;
  },
  setUserData(state, payload) {
    state.userData = payload;
  },
  setIsLogin(state, payload) {
    state.isLogin = payload;
  },
  setPhoneData(state, payload) {
    if (payload) {
      state.phoneCodeList = payload.phoneCodeList;
      state.phoneCode = payload.phoneCode;
      state.country = payload.country;
      let obj = {
        phoneCodeList: state.phoneCodeList,
        phoneCode: state.phoneCode,
        country: state.country,
      };
      localStorage.setItem("phoneData", JSON.stringify(obj));
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
